import urls from "global/constants/UrlConstants";
import { SortingConfig } from "models/interfaces";
import { getCallParams, makeCall } from "utils/service";

export const getUserRequestAnalyticsPage = async (
  page: number,
  payload: {
    searchText?: string;
    sortingConfig?: SortingConfig[];
  },
) => {
  try {
    const url = `${urls.GET_REPORT_USER_REQUESTS_PAGE}/${page}`;
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getUserRequestAnalyticsCount = async (payload: {
  searchText?: string;
}) => {
  try {
    const url = urls.GET_REPORT_USER_REQUESTS_COUNT;
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getTemplateEfficiencyPage = async (
  pageNo: number,
  payload: {
    dateRange: { fromDate: string; toDate: string };
    searchText?: string;
    sortingConfig?: SortingConfig[];
  },
) => {
  try {
    const url = `${urls.GET_TEMPLATE_EFFICIENCY_PAGE}/${pageNo}`;
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getTemplateEfficiencyCount = async (payload: {
  dateRange: { fromDate: string; toDate: string };
  searchText?: string;
}) => {
  try {
    const url = urls.GET_TEMPLATE_EFFICIENCY_COUNT;
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getRecipientsReportPage = async (
  pageNo: number,
  payload: {
    dateRange: { fromDate: string; toDate: string };
    searchText?: string;
  },
) => {
  try {
    const url = `${urls.GET_REPORT_RECIPIENTS_PAGE}/${pageNo}`;
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getRecipientsReportCount = async (payload: {
  dateRange: { fromDate: string; toDate: string };
  searchText?: string;
}) => {
  try {
    const url = urls.GET_REPORT_RECIPIENTS_COUNT;
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getRequestStatusCountMetrics = async (payload: {
  metricList: string[];
  dateRange: { fromDate: string; toDate: string };
}) => {
  try {
    const url = urls.GET_REPORT_REQUEST_STATUS_COUNTS;
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error) {
    throw error;
  }
};
